import React, {useEffect, useRef, useState} from 'react'
import {Link, useLocation, useNavigate} from 'react-router-dom'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faBars} from '@fortawesome/free-solid-svg-icons'
import {NavLink} from '../../types/app-types'
import classNames from 'classnames'

interface NavBarDropdownProps {
  navLinks: NavLink[]
  isAuthenticated: boolean
}

const NavBarDropdown = ({navLinks, isAuthenticated}: NavBarDropdownProps) => {
  const navigate = useNavigate()
  const location = useLocation()
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const menu = useRef(null)
  const menuButton = useRef(null)

  useEffect(() => {
    if (!isMenuOpen) {
      const activeElement = document.activeElement as HTMLElement
      activeElement.blur()
    } else if (isMenuOpen && !menu.current.contains(document.activeElement)) {
      setIsMenuOpen(false)
    }
  }, [isMenuOpen])

  return (
    <div className="dropdown dropdown-end" ref={menu}>
      <div
        tabIndex={0}
        className="btn btn-ghost rounded-btn"
        ref={menuButton}
        onBlur={e => {
          setIsMenuOpen(false)
        }}
        onClick={e => {
          if (isMenuOpen) {
            setIsMenuOpen(false)
          } else {
            setIsMenuOpen(true)
          }
        }}
      >
        <FontAwesomeIcon icon={faBars} className="text-lg" />
      </div>
      <ul
        tabIndex={0}
        className="mt-2 w-52 shadow menu menu-compact dropdown-content bg-base-100 w-52 text-black"
        onBlur={e => {
          menuButton.current.focus()
        }}
        onFocus={e => {
          setIsMenuOpen(true)
        }}
        onClick={e => {
          setIsMenuOpen(false)
        }}
      >
        {navLinks.map(({label, path}) => {
          return (
            <li key={path} className="lg:hidden">
              <Link to={path}>{label}</Link>
            </li>
          )
        })}

        <hr className="lg:hidden" />
        {isAuthenticated ? (
          <>
            <li>
              <Link to="/">Accounts Home</Link>
            </li>
            <hr />
            <li>
              <a onClick={e => navigate('/sign-out')}>Sign Out</a>
            </li>
          </>
        ) : (
          <li>
            <a
              onClick={e => {
                const {pathname, search} = location
                const redirectPath = encodeURIComponent(`${pathname}${search}`)
                navigate(`/sign-in?redirect=${redirectPath}`)
              }}
            >
              Sign In
            </a>
          </li>
        )}
      </ul>
    </div>
  )
}

export default NavBarDropdown
